import api from './axiosConfig';

export const paymentService = {
    async createPaymentIntent(amount: number, bookingId: string) {
        try {
            const response = await api.post('/payments/create-intent', {
                amount,
                bookingId
            });
            return response.data;
        } catch (error) {
            console.error('Failed to create payment intent:', error);
            throw error;
        }
    },

    async createVerificationSession(bookingId: string) {
        try {
            const response = await api.post('/payments/create-verification-session', {
                bookingId
            });
            return response.data;
        } catch (error) {
            console.error('Failed to create verification session:', error);
            throw error;
        }
    },

  // 3️⃣ Create Payment Transaction Record in Backend
  // Note: The backend should retrieve card_last4 from Stripe using the payment intent ID
  // since the frontend cannot access this information reliably
  async createPaymentRecord(payload: any) {
    try {
      const response = await api.post(
        "/payments/payments-transactions/create",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Failed to create payment record:", error);
      throw error;
    }
  },
}; 

